import Image from "next/image";
import { memo } from "react";
import { cn } from "@/lib/utils";

interface UserAvatarProps {
	src?: string | null;
	alt?: string;
	size?: number;
	className?: string;
}

const avatarOutlineClass =
	"outline outline-1 -outline-offset-1 outline-black/10 dark:outline-white/10";

export function UserAvatar({
	src,
	alt = "User avatar",
	size = 40,
	className = "",
}: UserAvatarProps) {
	const dimension = {
		width: size,
		height: size,
		minWidth: size,
	};

	if (src) {
		return (
			<Image
				src={src}
				alt={alt}
				width={size}
				height={size}
				className={cn(
					"rounded-full object-cover",
					avatarOutlineClass,
					className,
				)}
				style={dimension}
			/>
		);
	}

	return (
		<div
			className={cn(
				"rounded-full bg-gray-200 dark:bg-gray-700",
				avatarOutlineClass,
				className,
			)}
			style={dimension}
		/>
	);
}

export default memo(UserAvatar);
